import { UISchemaElement } from '@jsonforms/core';

export const getTopPropertyFromElements = (
  elements: UISchemaElement[] | undefined
): string | undefined => {
  if (!elements) return undefined;

  const visit = (
    el: UISchemaElement & { scope?: string; elements?: UISchemaElement[] }
  ): string | undefined => {
    if (!el) return undefined;
    if (el.type === 'Control' && typeof el.scope === 'string') {
      // Match '#/properties/<propName>' at the start of the scope
      const match = el.scope.match(/#\/properties\/([^/]+)/);
      if (match) {
        try {
          return decodeURIComponent(match[1]);
        } catch {
          return match[1];
        }
      }
    }
    if (Array.isArray(el.elements)) {
      for (const child of el.elements) {
        const res = visit(
          child as UISchemaElement & {
            scope?: string;
            elements?: UISchemaElement[];
          }
        );
        if (res) return res;
      }
    }
    return undefined;
  };

  for (const el of elements) {
    const res = visit(
      el as UISchemaElement & { scope?: string; elements?: UISchemaElement[] }
    );
    if (res) return res;
  }
  return undefined;
};
